import createListStore from "../stores/listStoreFactory";

export const useCensusStore = createListStore('census', )

export default useCensusStore